import { z } from 'zod';

import { AuditLogType } from '../../auditLog/AuditLogType';
import { AuditLogId, LosId } from '../../BrandedIds';
import { zodTemporalInstant } from '../../Temporal';
import { zodBrandedString, zodBrandedUuid } from '../../utils';

export const ExportableAuditLog = z
  .object({
    id: zodBrandedUuid<AuditLogId>(),
    loanId: zodBrandedString<LosId>(),
    type: AuditLogType,
    comment: z.string().optional(),
    createdAt: zodTemporalInstant,
    updatedAt: zodTemporalInstant,
  })
  .meta({ title: 'AuditLog' });
export type ExportableAuditLog = z.infer<typeof ExportableAuditLog>;
